<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M3.73828 3H3.65445V3.36866H3.73828V6.41017H1.84457V6.13281H1.5V6.41017V7.70049V7.97613H1.84457V7.70049H3.73828V13.0469H3.6543V13.4155H3.73828V18.207H1.84457V17.9307H1.5V18.207V19.4974V19.774H1.84457V19.4974H3.73828V22.6311H3.6543V22.9997H3.73828V23H4.94427V22.9997H5.37714V22.6311H4.94427V19.4974H7.70312V22.6311H7.61719V22.9997H7.70312V23H8.90912V22.9997H9.34003V22.6311H8.90912V19.4974H11.4922V19.774H11.8368V17.9307H11.4922V18.207H8.90912V16.9175H9.34003V16.5488H8.90912V11.0179H11.752V11.2953H12.0965V9.45203H11.752V9.72754H8.90912V7.70049H18.9863V7.97613H19.3309V7.70049H20.3654V11.5713H20.2793V11.94H20.3654V12.8622H19.3309V12.585H18.9863V12.8622H16.2314V11.1099H16.6623V10.7412H16.2314H15.0254H14.9395V11.1099H15.0254V12.8622H13.5594V12.585H13.2148V12.8622H13.043V14.1525H13.2148V14.4283H13.5594V14.1525H15.0254V18.207H13.4735V17.9307H13.1289V18.207H12.957V19.4974H13.1289V19.774H13.4735V19.4974H15.0254V22.6311H14.9395V22.9997H16.6623V22.6311H16.2314V19.4974H17.1777V19.774H17.5223V19.4974H20.3654V22.6311H20.2793V22.9997H20.3654V23H21.5714V22.9997H22.0021V22.6311H21.5714V19.4974H24.1543V19.774H24.4989V17.9307H24.1543V18.207H21.5714V14.1525H24.1543V14.4283H24.4989V12.585H24.1543V12.8622H21.5714V11.94H22.0021V11.5713H21.5714V7.70049H24.1543V7.97613H24.4989V6.13281H24.1543V6.41017H21.5714V3.36866H22.002V3H21.5714H20.3654H20.2791V3.36866H20.3654V6.41017H19.3309V6.13281H18.9863V6.41017H8.90912V3.36866H9.34003V3H8.90912H7.70312H7.61719V3.36866H7.70312V6.41017H6.66879V6.13281H6.32422V6.41017H4.94427V3.36866H5.3773V3H4.94427H3.73828ZM16.2314 18.207H17.1777V17.9307H17.5223V18.207H20.3654V14.1525H19.3309V14.4283H18.9863V14.1525H16.2314V18.207ZM7.70312 9.72754V7.70049H6.66879V7.97613H6.32422V7.70049H4.94427V13.0469H5.37714V13.4155H4.94427V18.207H7.70312V16.9175H7.61719V16.5488H7.70312V11.0179H6.66879V11.2953H6.32422V11.0179H6.15234V9.72754H6.32422V9.45203H6.66879V9.72754H7.70312Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgAFPMSummit2023',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>